//   在http.js中引入axios
import axios from 'axios'   //引入 axios
import router from '../router'  //引入router
import { Message } from 'element-ui'


const service = axios.create({
//    baseURL: 'http://101.37.146.114:8081',
    baseURL: 'https://hisgateway.zgtyyy.com',
/*    baseURL: 'http://192.168.124.4:8081',*/// api 的 base_url
/*    baseURL: 'http://192.168.43.50:8081',// api 的 base_url*/
    timeout: 100000, // request timeout  设置请求超时时间
})

service.interceptors.request.use(
    response => {
        return response; //拦截完再发送出去
    },
    error => {
        return Promise.reject(error);
    }
)
service.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 400:
                    Message.error(error.response.data.message)
                    break
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    Message.error('请重新登录')
                    // localStorage.removeItem('authorization');
                    // setTimeout(() => {
                    //     router.replace({
                    //         path: '/login',
                    //         query: {
                    //             redirect: router.currentRoute.fullPath
                    //         }
                    //     });
                    // }, 1000);
                    break;
                case 403:
                    if (error.response.data.error === 'access_denied') {
                        Message.error(error.response.data.error_description)
                    }
                    break;
                case 500:
                    Message.error('服务器错误')
                    break
                // 其他错误，直接抛出错误提示
                default:
                    Message.error(error.response.data.message)
            }
            return Promise.reject(error.response);
        }
    }
);
export default service